import {
  ROUTE_ARROW_IMAGE_ID_PREFIX,
  TRAIL_DOT_IMAGE_ID_PREFIX,
} from "../route-block-maplibre.constants";
import { TMapLibreRuntimeImages } from "./maplibre-missing-style-image.models";
import { ensureRouteArrowImage } from "./maplibre-route-arrow-image.utils";
import { ensureTrailDotImage } from "./maplibre-trail-dot-image.utils";

const TRAIL_DOT_IMAGE_ID_PATTERN =
  /^(#[0-9a-fA-F]{3,8})-(#[0-9a-fA-F]{3,8})-(\d+)-(\d+)$/;

/**
 * MapLibre v6: missing runtime images must be registered via `setMissingStyleImageResolver`,
 * not from a `styleimagemissing` listener calling `addImage`. Call this as soon as the map
 * instance exists (layout effect), not from `onLoad` — the first style pass already asked
 * for `icon-image` by then and logs "could not be loaded".
 */
export const resolveMissingMapLibreStyleImage = ({
  map,
  id,
}: {
  map: TMapLibreRuntimeImages;
  id: string;
}): void => {
  if (id.startsWith(ROUTE_ARROW_IMAGE_ID_PREFIX)) {
    ensureRouteArrowImage(map, {
      color: id.slice(ROUTE_ARROW_IMAGE_ID_PREFIX.length),
    });
    return;
  }

  if (!id.startsWith(TRAIL_DOT_IMAGE_ID_PREFIX)) {
    return;
  }

  const trailDotSuffix = id.slice(TRAIL_DOT_IMAGE_ID_PREFIX.length);
  const trailDotMatch = trailDotSuffix.match(TRAIL_DOT_IMAGE_ID_PATTERN);
  if (!trailDotMatch) {
    return;
  }

  ensureTrailDotImage(map, {
    color: trailDotMatch[1],
    strokeColor: trailDotMatch[2],
    radiusPx: Number(trailDotMatch[3]),
    strokeWidthPx: Number(trailDotMatch[4]),
  });
};

export const registerMapLibreMissingStyleImageResolver = (
  map: TMapLibreRuntimeImages,
): void => {
  map.setMissingStyleImageResolver(id => {
    resolveMissingMapLibreStyleImage({ map, id });
  });
};
